import { stateListApi } from "../../api/state/stateListApi"
import { State } from "../../entities/state"

type PayloadShape = Parameters<typeof stateListApi>[0]

export async function stateListService(payload: PayloadShape, token?: null | string) {
	const state = await stateListApi(payload, token)
	return state as NonNullable<State[]>
}
